'use strict'
var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault')
require('core-js/modules/es.array.concat')
require('core-js/modules/es.array.for-each')
require('core-js/modules/es.array.join')
require('core-js/modules/es.array.map')
require('core-js/modules/es.parse-int')
require('core-js/modules/es.regexp.exec')
require('core-js/modules/es.string.replace')
require('core-js/modules/es.string.split')
require('core-js/modules/es.string.trim')
require('core-js/modules/web.dom-collections.for-each')
exports.__esModule = true
exports.default = void 0
var _createClass2 = _interopRequireDefault(require('@babel/runtime/helpers/createClass'))
var _assertThisInitialized2 = _interopRequireDefault(
  require('@babel/runtime/helpers/assertThisInitialized')
)
var _inheritsLoose2 = _interopRequireDefault(require('@babel/runtime/helpers/inheritsLoose'))
var _defineProperty2 = _interopRequireDefault(require('@babel/runtime/helpers/defineProperty'))

var _is = require('../is')
var _Time = _interopRequireDefault(require('../Time'))
var _inherent = _interopRequireDefault(require('./inherent'))
var _utils = require('./utils')
var MAX_SEC_IN_DAY = _Time.default.MAX_SEC_IN_DAY,
  _Time$convert = _Time.default.convert,
  hmsToSec = _Time$convert.hmsToSec,
  secToHms_arrStr = _Time$convert.secToHms_arrStr

var parensRegex = /^\(|\)$/g
var validatorParensRegex = /^\(.*\)$/

/* eslint-disable class-methods-use-this */

/**
 * TimeVal
 *
 *
 * @class TimeVal
 * @extends {Inherent}
 * @implements {ValsInterface}
 *
 */ var TimeVal = /*#__PURE__*/ (function(_Inherent) {
  ;(0, _inheritsLoose2.default)(TimeVal, _Inherent)
  function TimeVal() {
    var _this
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key]
    }
    _this = _Inherent.call.apply(_Inherent, [this].concat(args)) || this
    ;(0, _defineProperty2.default)(
      (0, _assertThisInitialized2.default)(_this),
      'name',

      'time'
    )
    return _this
  }
  var _proto = TimeVal.prototype
  _proto.secToPeriodPairs = function secToPeriodPairs(sec) {
    var periods = []

    for (var i = 0; i < sec.length; i++) {
      var start = sec[i]
      var end = sec[i + 1]
      periods.push([start, end])
      i++
    }

    return periods
  }

  /**
   * @param {string} hmsStr 21:30:59
   * @returns {number} 85399
   * @memberof TimeVal
   */
  _proto.hmsStrToSec = function hmsStrToSec(hmsStr) {
    var hmsArr = hmsStr.split(':').map(function(n) {
      return parseInt(n)
    })
    return hmsToSec(hmsArr)
  }

  /**
   * @param {string} hmsPeriodStr 20:20:01-21:30:59
   * @returns {OnePeriodType} [ 200, 379 ]
   * @memberof TimeVal
   */
  _proto.hmsStrPeriodToSec = function hmsStrPeriodToSec(hmsPeriodStr) {
    var _hmsPeriodStr$split = hmsPeriodStr.split('-'),
      start = _hmsPeriodStr$split[0],
      end = _hmsPeriodStr$split[1]
    return [this.hmsStrToSec(start), this.hmsStrToSec(end)]
  }

  /**
   * @param {ValidStrType} s (19:00:00-19:01:00,20:20:01-21:30:59)
   * @returns {ValidValType} [ seconds, seconds, 0, 86399 ]
   * @memberof TimeVal
   */
  _proto.parseStr = function parseStr(s) {
    var _this2 = this
    var seconds = []
    s.trim()
      .replace(parensRegex, '')
      .split(',')
      .forEach(function(strPeriod) {
        seconds.push.apply(seconds, _this2.hmsStrPeriodToSec(strPeriod))
      })
    return seconds
  }

  /**
   * @param {OnePeriodType} periodArr [ 200, 379 ]
   * @returns {string} 00:33:53-03:07:13
   * @memberof TimeVal
   */
  _proto.stringifyPeriodArr = function stringifyPeriodArr(periodArr) {
    var concatHms = function concatHms(sec) {
      return secToHms_arrStr(sec).join(':')
    }
    var start = periodArr[0],
      end = periodArr[1]
    return concatHms(start) + '-' + concatHms(end)
  }

  /**
   * @param {ValidValType} seconds [ 200, 379,18131, 79511 ]
   * @returns {ValidStrType} (00:00:00-00:20:30,00:33:53-03:07:13)
   * @memberof TimeVal
   */
  _proto.stringify = function stringify(seconds) {
    var periods = this.secToPeriodPairs(seconds)
    var periodsStr = periods.map(this.stringifyPeriodArr).join(',')
    return '(' + periodsStr + ')'
  }
  _proto.fmt = function fmt(opts) {
    var rangeDel = ' - '
    var periodsDel = ' / '
    if ((0, _is.isObj)(opts)) {
      if ((0, _is.isStr)(opts.rangeDelimiter)) {
        rangeDel = opts.rangeDelimiter
      }
      if ((0, _is.isStr)(opts.periodsDelimiter)) {
        periodsDel = opts.periodsDelimiter
      }
    }

    var periods = this.secToPeriodPairs(this.val)
    return periods
      .map(function(period) {
        var concatHms = function concatHms(sec) {
          return secToHms_arrStr(sec).join(':')
        }
        var start = period[0],
          end = period[1]
        return '' + concatHms(start) + rangeDel + concatHms(end)
      })
      .join(periodsDel)
  }
  _proto.validateStr = function validateStr(s) {
    var isValid = (0, _is.isStr)(s) && validatorParensRegex.test(s)
    return isValid ? s : null
  }
  _proto.validateVal = function validateVal(val) {
    var isValid =
      (0, _is.isArr)(val) &&
      val.length > 1 &&
      val.length % 2 === 0 &&
      (0, _utils.validateNumsArr)(val, MAX_SEC_IN_DAY)
    return isValid ? val : null
  }
  ;(0, _createClass2.default)(TimeVal, [
    {
      key: 'defaultTime',
      get: function get() {
        return [0, MAX_SEC_IN_DAY]
      }
    },
    {
      key: 'isAny',
      get: function get() {
        var val = this.val
        return val.length === 0 || (val.length === 2 && val[0] === 0 && val[1] === MAX_SEC_IN_DAY)
      }
    }
  ])
  return TimeVal
})(_inherent.default)
exports.default = TimeVal



//////////////////
// WEBPACK FOOTER
// ./~/hlp/dist/TimingParser/time.js
// module id = 633
// module chunks = 0